import Vue from 'vue'

const state = {
  baseUri: '/botw/main/admin/'
}
const getters = {
}
const actions = {
  situationList: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 전년도 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'situationList',
      params: paramData.orderContractCompSeq
    }
    console.log('actions situationList axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  searchContractPerYear: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 금년도 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'searchContractPerYear',
      params: paramData.orderContractCompSeq
    }
    console.log('actions searchContractPerYear axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  prevRegionCheck: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 전월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'prevRegionCheck',
      params: paramData.orderContractCompSeq
    }
    console.log('actions prevRegionCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  currRegionCheck: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 금월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'currRegionCheck',
      params: paramData.orderContractCompSeq
    }
    console.log('actions currRegionCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contExpireList: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 금월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'contExpireList',
      params: paramData.orderContractCompSeq
    }
    console.log('actions contExpireList axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
